var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10348",
    "data-name": "Group 10348",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.886,
    height: 65.886,
    viewBox: "0 0 65.886 65.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 65.886,
    height: 65.886,
    fill: "#ffbd00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27728",
    "data-name": "Path 27728",
    d: "M50.513,65.886A6.943,6.943,0,0,1,43.924,59.3V57.1H21.962v2.2a6.6,6.6,0,0,1-6.589,6.589A6.943,6.943,0,0,1,8.785,59.3V57.1h-2.2A6.372,6.372,0,0,1,0,50.513V32.943a6.6,6.6,0,0,1,5.13-6.425L7.947,9.294A11.176,11.176,0,0,1,18.9,0H46.554a11.163,11.163,0,0,1,10.94,9.224l2.817,17.224a7.006,7.006,0,0,1,5.575,6.495v17.57A6.372,6.372,0,0,1,59.3,57.1H57.1v2.2a6.6,6.6,0,0,1-6.589,6.589M19.766,52.709H46.12a2.2,2.2,0,0,1,2.2,2.2V59.3a2.572,2.572,0,0,0,2.2,2.2,2.2,2.2,0,0,0,2.2-2.2V54.905a2.2,2.2,0,0,1,2.2-2.2H59.3a1.98,1.98,0,0,0,2.2-2.2V32.943a2.572,2.572,0,0,0-2.2-2.2h-.867a2.2,2.2,0,0,1-2.173-1.839L53.172,10a6.706,6.706,0,0,0-6.618-5.611H18.9a6.729,6.729,0,0,0-6.63,5.687L9.189,28.908a2.191,2.191,0,0,1-2.167,1.839,2.337,2.337,0,0,0-2.63,2.2v17.57a1.98,1.98,0,0,0,2.2,2.2h4.392a2.2,2.2,0,0,1,2.2,2.2V59.3a2.572,2.572,0,0,0,2.2,2.2,2.2,2.2,0,0,0,2.2-2.2V54.905a2.2,2.2,0,0,1,2.2-2.2m30.747-4.392a6.372,6.372,0,0,1-6.589-6.589,6.589,6.589,0,1,1,13.177,0,6.6,6.6,0,0,1-6.589,6.589m0-8.785a1.98,1.98,0,0,0-2.2,2.2,1.98,1.98,0,0,0,2.2,2.2,2.2,2.2,0,0,0,2.2-2.2,1.98,1.98,0,0,0-2.2-2.2M15.373,48.317a6.372,6.372,0,0,1-6.589-6.589,6.372,6.372,0,0,1,6.589-6.589,6.372,6.372,0,0,1,6.589,6.589,6.6,6.6,0,0,1-6.589,6.589m0-8.785a1.98,1.98,0,0,0-2.2,2.2,1.98,1.98,0,0,0,2.2,2.2,2.2,2.2,0,0,0,2.2-2.2,1.98,1.98,0,0,0-2.2-2.2m34.273-8.785H15.807a2.2,2.2,0,0,1-2.161-2.577L16.738,10.6A2.193,2.193,0,0,1,18.9,8.785H46.554A2.193,2.193,0,0,1,48.715,10.6l3.092,17.57a2.2,2.2,0,0,1-2.161,2.577M18.425,26.354h28.6L44.715,13.177H20.744Z",
    fill: "#ffbd00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon2);
export default __webpack_public_path__ + "static/media/social_icon2.46e73fc2d8d8e0e8bc8b6e9d867ccb50.svg";
export { ForwardRef as ReactComponent };